import Fetch from 'jsx/common/util/_fetch';
type PermissionBody = {
  permission: number | number[];
  user?: string;
  group?: string;
};

interface ObjectPermissionBody extends PermissionBody {
  object_id: string;
  content_type: number;
}

export const permission = {
  get: async (groupId: string) => {
    return Fetch.get(`/api/group/${groupId}/permissions/`);
  },
  objectToggle: async (
    permission: ObjectPermissionBody,
    object_permission_id?: string
  ) => {
    if (object_permission_id)
      return Fetch.delete(
        `/api/group/object-permission/${object_permission_id}/`
      );

    return Fetch.post(`/api/group/object-permission/`, {
      body: JSON.stringify(permission),
    });
  },
  objectDelete: async (object_permission_ids: string[]) => {
    return Promise.all(
      object_permission_ids.map(id =>
        Fetch.delete(`/api/group/object-permission/${id}/`)
      )
    );
  },
};
